import { strategyToOptions } from "@/common/utils/strategyToOptions"
import { CalendarClockIcon, CheckCheckIcon, ClockIcon } from "lucide-react"

export const bankingDepositStatus = {
  paid: 'Pago',
  pending: 'Esperando pagamento',
  expired: 'Expirado',
}

export const bankingDepositStatusOptions = strategyToOptions(bankingDepositStatus);

export const bankingDepositStatusComponent = {
  paid: {
    iconBackgroundClassName: 'bg-green-600',
    iconClassName: '',
    icon: CheckCheckIcon,
    titleClassName: 'text-valid',
    title: 'Pagamento realizado',
    subtitle: 'Seu pagamento foi confirmado com sucesso!',
  },
  pending: {
    iconBackgroundClassName: 'bg-yellow-500',
    iconClassName: 'text-neutral-900',
    icon: ClockIcon,
    titleClassName: 'text-yellow-400',
    title: 'Aguardando pagamento',
    subtitle: 'Seu depósito foi gerado. Realize o pagamento.',
  },
  expired: {
    iconBackgroundClassName: 'bg-danger',
    iconClassName: '',
    icon: CalendarClockIcon,
    titleClassName: 'text-danger-soft',
    title: 'Pagamento expirado',
    subtitle: 'Seu pagamento foi expirado. Refaça se necessário.',
  }
}
